import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { loginApi, ApiError } from "@/lib/api";
import { useAuthActions } from "@/store/authStore";
import { useLoading } from "@/store/loadingStore";
import { useModal } from "@/store/modalStore";

/**
 * 로그인 뷰 컴포넌트
 * @returns {JSX.Element} 로그인 화면
 */
const LoginView = () => {
  const navigate = useNavigate();

  // Store hooks
  const { login } = useAuthActions();
  const { startLoading, stopLoading } = useLoading();
  const modal = useModal();

  // 상태 관리
  const [formData, setFormData] = useState({
    userId: "",
    password: "",
    rememberMe: false,
  });

  // 입력 값 변경 핸들러
  const handleInputChange = (e) => {
    const { name, value, type, checked } = e.target;
    setFormData((prev) => ({
      ...prev,
      [name]: type === "checkbox" ? checked : value,
    }));
  };

  // 로그인 처리
  const handleLogin = async (e) => {
    e.preventDefault();

    startLoading('로그인 중...');

    try {
      // API 호출
      const data = await loginApi({
        userId: formData.userId,
        password: formData.password,
        rememberMe: formData.rememberMe,
      });

      // Store에 사용자 정보 저장 (localStorage 자동 저장됨)
      login({
        userId: data.userId,
        userName: data.name,
        adminGrade: data.adminGrade,
        token: data.token,
      });

      // 아이디 저장 처리
      if (formData.rememberMe) {
        localStorage.setItem("savedUserId", formData.userId);
      } else {
        localStorage.removeItem("savedUserId");
      }

      // 성공 메시지 (선택사항)
      // modal.alert('로그인 성공', '환영합니다!');

      // 대시보드로 이동
      navigate("/dashboard");
    } catch (error) {
      console.error("로그인 오류:", error);

      // 에러 모달로 표시
      if (error instanceof ApiError) {
        modal.alert('로그인 실패', error.message);
      } else {
        modal.alert(
            '로그인 실패',
            '로그인 중 오류가 발생했습니다. 잠시 후 다시 시도해주세요.'
        );
      }
    } finally {
      stopLoading();
    }
  };

  // 컴포넌트 마운트 시 저장된 아이디 불러오기
  useEffect(() => {
    const savedUserId = localStorage.getItem("savedUserId");
    if (savedUserId) {
      setFormData((prev) => ({
        ...prev,
        userId: savedUserId,
        rememberMe: true,
      }));
    }
  }, []);

  return (
      <div className="login_wrap">
        <div className="login_in1">
          <div className="login_w1">
            <form onSubmit={handleLogin}>
              {/* 아이디 입력 */}
              <div className="login_dv1">
                <div className="w1">
                  <img src="/img/login_img01.png" alt="아이디" />
                </div>
                <div className="w2">
                  <input
                      type="text"
                      name="userId"
                      value={formData.userId}
                      onChange={handleInputChange}
                      placeholder="아이디를 입력하세요"
                      required
                  />
                </div>
              </div>

              {/* 비밀번호 입력 */}
              <div className="login_dv1 tp02">
                <div className="w1">
                  <img src="/img/login_img02.png" alt="비밀번호" />
                </div>
                <div className="w2">
                  <input
                      type="password"
                      name="password"
                      value={formData.password}
                      onChange={handleInputChange}
                      placeholder="비밀번호를 입력하세요"
                      required
                  />
                </div>
              </div>

              {/* 아이디 저장 체크박스 */}
              <div className="login_dv2">
                <input
                    type="checkbox"
                    name="rememberMe"
                    id="rememberMe"
                    checked={formData.rememberMe}
                    onChange={handleInputChange}
                />
                <label htmlFor="rememberMe">
                  <p>아이디 저장</p>
                </label>
              </div>

              {/* 로그인 버튼 */}
              <div className="login_dv3">
                <button
                    type="submit"
                    className="login-btn"
                >
                  <img src="/img/btn_login01.png" alt="로그인" />
                </button>
              </div>
            </form>
          </div>
        </div>
      </div>
  );
};

export default LoginView;